import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FacebookSVG = function FacebookSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M30,16.08A14,14,0,1,0,13.81,30V20H10.26V16h3.55V13c0-3.53,2.09-5.48,5.29-5.48a20.46,20.46,0,0,1,3.13.28v3.46H20.47A2,2,0,0,0,18.2,13a1.7,1.7,0,0,0,0,.45V16h3.88l-.62,4H18.19V30A14.06,14.06,0,0,0,30,16.08Z"
  }));
};
FacebookSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FacebookSVG);